import * as requestFromServer from './popupEditRowDataCrud';
import moment from 'moment';
import {popupEditRowDataSlice, callTypes} from './popupEditRowDataSlice';
import {invoiceOrdersEditAndSendSlice} from './invoiceOrdersEditAndSendSlice';
import {logUserAction} from '../../../../utils';
import {pages as P} from '../../_common/constants/pages';
import {subjects as S} from '../../_common/constants/subjects';
import {actionTypes as T} from '../../_common/constants/actionTypes';
import {logMessages as L} from '../../_common/constants/logMessages';

const {actions} = popupEditRowDataSlice;
const actionsTable = invoiceOrdersEditAndSendSlice.actions;

export const getPopupEditRowData = invoiceOrderID => dispatch => {
  dispatch(actions.startCall({callType: callTypes.data}));

  return requestFromServer
    .findPopupEditRowData(invoiceOrderID)
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) throw new Error();

      dispatch(actions.popupEditRowDataFetched({
        entities: data
      }));
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t find row data';
      dispatch(actions.catchError({error, callType: callTypes.data}));
    });
};

export const editRowData = (values, agentID) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.data}));

  return requestFromServer
    .editInvoiceOrder(values)
    .then(response => {
      const {errorCode, data} = response.data;
      logUserAction(
        P.INVOICE_ORDERS,
        S.INVOICE_ORDER,
        T.EDIT,
        L.INVOICE_ORDERS_EDIT(
          data?.totalAmount,
          data?.createdAt ? moment(data?.createdAt).format('DD-MM-YYYY') : '',
          agentID
        ),
       errorCode
      );

      if (errorCode === 0) {
        dispatch(actionsTable.invoiceOrderEdited({
          canCreate: data.canCreate,
          createdAt: data.createdAt,
          customerName: data.customerName,
          phone: data.phone,
          totalAmount: data.totalAmount,
          status: data.status,
          statusText: data.statusText,
          _id: data._id,
        }));
      } else {
        throw new Error();
      }

      return errorCode;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t edit row data';
      dispatch(actions.catchError({error, callType: callTypes.data}));
    });
};
